const FLOWS = [
  {
    id: "overdue",
    steps: [
      { label: "Watch", copy: "Invoice 7 days overdue" },
      { label: "Decide", copy: "Skip accounts on payment plans" },
      { label: "Act", copy: "Send the statement - replies thread back in" },
    ],
  },
  {
    id: "job-complete",
    steps: [
      { label: "Watch", copy: "Job marked complete in the field" },
      { label: "Decide", copy: "Check sign-off, parts used and hours" },
      { label: "Act", copy: "Update stock, close the job, bill it - no re-typing" },
    ],
  },
];

/**
 * The workflow-automation section: the client describes the outcome in plain
 * English and we configure the workflow for them.
 *
 * ⚠️ The builder is not released to clients. The exchange below is deliberately
 * client → Larasoft, NOT client → Lara: attributing the build to the AI would
 * promise self-service that does not exist. Keep the second speaker "Larasoft".
 */
export function WorkflowShowcase() {
  return (
    <div className="space-y-6">
      <div className="rounded-2xl border border-white/10 bg-white/5 p-6 font-mono text-sm">
        <p className="text-white">
          <span className="font-semibold text-brand-turquoise">You: </span>
          “When stock for any A-class item drops below its reorder point, check
          open POs and the supplier's lead time, then draft a purchase order for
          approval.”
        </p>
        <p className="mt-3 text-emerald-300">
          <span className="font-bold">Larasoft: </span>
          Built and dry-run against your last 90 days - 4 steps. Live as soon as
          you approve it.
        </p>
      </div>

      <div className="space-y-4">
        {FLOWS.map((flow) => (
          <div
            key={flow.id}
            className="grid grid-cols-1 gap-4 rounded-2xl border border-white/10 bg-white/5 p-6 sm:grid-cols-3"
          >
            {flow.steps.map((step) => (
              <div key={step.label}>
                <p className="text-[11px] font-extrabold uppercase tracking-widest text-brand-turquoise">
                  {step.label}
                </p>
                <p className="mt-1 font-mono text-sm text-slate-300">
                  {step.copy}
                </p>
              </div>
            ))}
          </div>
        ))}
      </div>

      <p className="max-w-2xl text-slate-400">
        Every workflow runs on the same trusted database as your reporting -
        logged, cited, and dry-run before it goes live. Ask Lara what happened,
        and she can tell you.
      </p>
    </div>
  );
}
